module.exports = __webpack_public_path__ + "img/monitor_72.0bd2f8ad.jpg";